import { AlertType, ToastrAlert } from '@/shared/models/toastr-alert.interface';
import { Component, ElementRef, ViewChild } from '@angular/core';

declare const window: any;

@Component({
  selector: 'app-toastr-alert',
  templateUrl: './toastr-alert.component.html',
})
export class ToastrAlertComponent {
  toastAlert: ToastrAlert | null = null;

  @ViewChild('toastRef') toastRef!: ElementRef;
  toastInstance: any;

  get toastClasses(): string {
    switch (this.toastAlert?.type) {
      case AlertType.SUCCESS:
        return 'text-bg-success';
      case AlertType.ERROR:
        return 'text-bg-danger';
      case AlertType.WARNING:
        return 'bg-primary text-white';
      default:
        return 'bg-secondary';
    }
  }

  showSuccessToast(message: string) {
    this.toastAlert = { type: AlertType.SUCCESS, message };
    this.showToast();
  }

  showErrorToast(message: string) {
    this.toastAlert = { type: AlertType.ERROR, message };
    this.showToast();
  }

  showWarningToast(message: string) {
    this.toastAlert = { type: AlertType.WARNING, message };
    this.showToast();
  }

  showToast() {
    setTimeout(() => {
      if (this.toastInstance) {
        this.toastInstance.dispose();
      }
      this.toastInstance = new window.bootstrap.Toast(this.toastRef.nativeElement);
      this.toastInstance.show();
    });
  }
}
